<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Instrument Score Information</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Users</label>
          <select class="custom-select" [(ngModel)]="Selected_User_Id" name="Selected_User_Id">
            <option value="0">All</option>
            <option *ngFor="let item of DataList_Kartable_Option" [value]="item.username">{{item.name}} {{item.familly}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">

          <button *ngIf="!Procssing" type="button" (click)="ReadData_User(datepickerInputStart.value,datepickerInputEnd.value)"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-right: 5px;">
            <i class="fa   fa-file-excel-o"></i>Excel
          </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Calibration Technician Name </th>
              <th>Instrument Name </th>
              <th>Instrument Tariff</th>
              <th>Decree or Assignment Number </th>
              <th>Count Equipment</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Kartable| paginate
            : {
                id: 'DataList_KartableTable',
                itemsPerPage: 20,
                currentPage: page,
                totalItems: (DataList_Kartable
                ).length
              }">
              <td>{{DataList_Kartable.indexOf(item)+1}}</td>
               <td>{{item.fullname}}</td>
               <td>{{item.title}}</td>
               <td>{{item.dsc}}</td>
               <td>
                <ul *ngIf="item.letter.length>0">
                  <li *ngFor="let item_letter of item.letter">{{item_letter}}</li>
                </ul>
               </td>
               <td>{{item.amount || number}} items</td>
               <td>{{item.point || number}}</td>
             </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_KartableTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<table id="excel-table" style="display: none;" >
  <thead >
    <tr>
      <th>#</th>
      <th>Calibration Technician Name </th>
      <th>Instrument Name </th>
      <th>Instrument Tariff</th>
      <th>Count Equipment</th>
      <th>Score</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Kartable">
      <td>{{DataList_Kartable.indexOf(item)+1}}</td>
      <td>{{item.fullname}}</td>
      <td>{{item.title}}</td>
      <td>{{item.dsc}}</td>
      <td>{{item.amount || number}} items</td>
      <td>{{item.point || number}}</td>
     </tr>
  </tbody>
</table>
